.initials {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1.5px solid var(--ink);
  border-radius: 999px;
  background: var(--sunk);
  color: var(--ink-2);
  font-size: 14px;
  font-weight: 700;
}

.large {
  width: 52px;
  height: 52px;
  border-width: 2px;
  background: var(--accent-soft);
  color: var(--ink);
  font-size: 18px;
}
